/* eslint-disable max-len */
export const landing = {
  'answer-on-questions': 'Сұрақтарға жауап беріңіз',
  'candidate-page-title': 'Үміткер сауалнамасы',
  'choose-vacancy': 'Вакансияны таңдаңыз',
  'data-processing-and-agreement-links': 'Мен жұмысқа орналасу мүмкіндігі мақсатында <a href="/pd_processing_policy_kz.pdf" class="text-primary-100" target="_blank">дербес деректерімді өңдеуге</a> келісім беремін және <a href="/user_agreement_sm_podbor_kz.pdf" class="text-primary-100" target="_blank">Пайдаланушылық келісімді</a> қабылдаймын',
  'do-you-lead-a-healthy-lifestyle': 'Саламатты өмір салтын ұстанасыз ба?',
  'do-you-play-sport': 'Спортпен шұғылданасыз ба?',
  'type-full-name': 'ТАӘ енгізіңіз',
  'type-first-name': 'Атын енгізіңіз',
  'type-last-name': 'Тегін енгізіңіз',
  'type-patronymic-name': 'Әкесінің атын енгізіңіз',
  'full-name': 'Т.А.Ә.',
  'error:birthday': 'Туған күнді таңдаңыз',
  'error:citizenship': 'Азаматтықты таңдаңыз',
  'error:city': 'Қаланы таңдаңыз',
  'error:email': 'E-mail енгізіңіз',
  'error:correct-email': 'E-mail енгізіңіз',
  'error:type-full-name': 'Тегіңізді, атыңызды және әкеңіздің атын арасына бос орын тастап, ТАӘ енгізіңіз',
  'error:type-first-name': 'Атын енгізіңіз',
  'error:type-last-name': 'Тегін енгізіңіз',
  'error:type-patronymic-name': 'Әкесінің атын енгізіңіз',
  'error:expected-income-level': 'Күтілетін табыс деңгейін енгізіңіз',
  'error:phone': 'Телефонды енгізіңіз',
  'error:phone-number': 'Телефонды енгізіңіз',
  'error:prefered-communication-method': 'Қолайлы байланыс тәсілін таңдаңыз',
  'error:prefered-schedule': 'Кестені таңдаңыз',
  'error:store': 'Дүкенді таңдаңыз',
  'error:recommender-city': 'Қаланы енгізіңіз',
  'expected-income-level': 'Күткен табыс деңгейі, ₸',
  'fill-personal-data': 'Дербес деректерді толтырыңыз',
  'fill-required-fields': 'Міндетті жолдарды толтырыңыз!',
  'for-example-basketball': 'Мысалы, баскетбол',
  'generating-telegram-link-please-wait': 'Telergam-ботқа сілтемелер қалыптастырылуда. Беттен кетпеңіз, бұл бірнеше секунд алуы мүмкін.',
  'go-to-telegram': 'Telegram-ға өту',
  'if-you-have-trouble-to-fill-form': 'Сауалнаманы толтырғанда қиындық туындаса — 8 800 350 80 60 нөміріне қоңырау шалыңыз',
  'if-you-have-trouble-to-fill-form-email': `Егер сізде сауалнаманы толтырғанда қиындықтар туындаса - жазыңыз
    <a href="mailto:Support_smpodbor@sportmaster.com">Support_smpodbor@sportmaster.com</a>`,
  'full-name-exemplicant': 'Ильясов Ильяс Ильясұлы',
  'first-name-exemplicant': 'Ильяс',
  'last-name-exemplicant': 'Ильясов',
  'patronymic-name-exemplicant': 'Ильясұлы',
  'link-our-telegram-for-more-info': 'Сұхбаттың келесі кезеңдері туралы ақпаратты жылдамырақ алу үшін біздің <a :href="telegramLink" class="text-primary-100" target="_blank">Telegram-ға</a> өтіңіз',
  'online-stage-personal-link-email': 'Онлайн-кезеңнен өту үшін поштаңызға жеке сілтеме жіберіледі.',
  'online-stage-video-recording-agreement': 'Онлайн-кезеңнен өту кезінде видео жазуға рұқсат беремін.',
  'phone-number': 'Телефон нөмірі',
  'prefered-communication-method': 'Қолайлы байланыс тәсілі',
  'prefered-schedule': 'Қалаулы кесте',
  'previous-step': 'Алдыңғы қадам',
  'profile-vk': 'VK профилі',
  'questionnaire-sent-successfully': 'Сауалнама сәтті жіберілді',
  'online-stage-personal-link-sent-on-your-email': 'Онлайн-кезеңнен өту үшін поштаңызға <strong>{userEmail}</strong>жеке сілтеме жіберілді',
  'sales-representative': 'Сауда өкілі',
  'system-administrator': 'Жүйе әкімшісі',
  'type-birthday': 'Туған күніңізді енгізіңіз',
  'type-profile-vk-link': 'VK профиліңіздің сілтемесін енгізіңіз',
  'write-what-sport-do-you-do': 'Мысалы, баскетбол',
  'fill-questionnaire': 'Сауалнамадағы деректерді толтырыңыз',
  birthday: 'Туған күн',
  citizenship: 'Азаматтық',
  city: 'Қала',
  loader: 'Жүкші',
  next: 'Әрі қарай',
  partner: 'Серіктес',
  phone: 'Телефоның',
  email: 'E-mail',
  step: 'Қадам',
  store: 'Дүкен',
  ITN: 'ЖСН',
  MSRN: 'БСН',
  code: 'Код',
  'send-questionnaire': 'Сауалнаманы жіберу',
  'recommender-data-title': 'Ұсыным берушінің деректері',
  'has-work-in-this-company-before': 'Бұрын Sportmaster-де жұмыс істеген',
};
